import { LmIconFilledFilesFileText, LmIconOutlineFilesFileText } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionProforientationApplicationsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineFilesFileText {...rest} /> : <LmIconFilledFilesFileText {...rest} />;

export default IconProfessionProforientationApplicationsCommon;
